// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1bkJE","question":"styles_question__2y_SR","description":"styles_description__nXw6-"};